import { z } from 'zod';
import { cardSchema } from './card';

export const agentEventSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('started'),
        conversationId: z.string().min(1),
    }),
    z.object({
        type: z.literal('tool_call'),
        id: z.string().min(1),
        kpi: z.string().min(1),
        summary: z.string().min(1),
        params: z.record(z.string(), z.unknown()),
    }),
    z.object({
        type: z.literal('result'),
        toolCallId: z.string().min(1),
        card: cardSchema,
    }),
    z.object({
        type: z.literal('tool_error'),
        toolCallId: z.string().min(1),
        reason: z.string(),
    }),
    z.object({
        type: z.literal('final_answer_tokens'),
        text: z.string(),
    }),
    z.object({
        type: z.literal('error'),
        userMessage: z.string().min(1),
    }),
    z.object({ type: z.literal('done') }),
]);

export type AgentEvent = z.infer<typeof agentEventSchema>;
export type AgentEventType = AgentEvent['type'];
